import React from 'react';
import Game from './Game';
import { Link } from 'react-router-dom';
import { BsPlusSquareFill } from 'react-icons/bs';



// Change the function names and parameters 
// to fit your portfolio topic and schema.

function GameList({ games, onDelete, onEdit }) {
    return (
        <table id="games">
            <thead>
                <tr>
                    <th>Delete</th>
                    <th>Edit</th>
                    <th>Game Stadium</th>
                    <th>Braves' Score</th>
                    <th>Game Date</th>
                    <th>
                        <Link to="/create">
                            <BsPlusSquareFill className="create-icon" title="Create" />
                        </Link>
                    </th>
                </tr>
            </thead>
            <tbody>
                {games.map((game, i) => 
                    <Game 
                        game={game} 
                        key={i}
                        onDelete={onDelete}
                        onEdit={onEdit} 
                    />)}
            </tbody>
        </table>
    );
}

export default GameList;
